import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The most fun you can have offline",
  "description": "",
  "published": "2012-04-17T00:00:00.000Z",
  "redirect_from": ["/blog/the-most-fun-you-can-have-offline/swizec/4146"],
  "categories": "Longboard, Skateboard, Sport, Travel + Events",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/04/383380_347698125278305_146707288710724_862402_1645891238_n.jpg",
        "alt": "Me on a longboard",
        "title": "Me on a longboard"
      }}></img></p>
    <p>{`I don't even come close to the ridiculously photogenic guy, but just `}<em parentName="p">{`look`}</em>{` at that smile! Look at it! That is true joy. I'm as happy as a corgi on stilts as the internet would say.`}</p>
    <p>{`The photo is from a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Longboarding",
        "title": "Longboarding"
      }}>{`longboarding`}</a>{` class, organized by `}<a parentName="p" {...{
        "href": "http://www.longboard.si/"
      }}>{`Longboard Magazin`}</a>{`, I went to last Monday instead of nurturing an easter food hangover at home. I went again this Sunday, simply because the first one made me smile like `}<em parentName="p">{`that`}</em>{`.`}</p>
    <p>{`My `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/seems-i-am-in-love-with-learning/swizec/2442"
      }}>{`first experience on a longboard`}</a>{` was a lot sillier than that photo:`}</p>
    <blockquote>
      <p parentName="blockquote">{`Three days ago I was such a noob at this stuff it took me longer to get home from college than it would on foot. Now it’s as quick as rollerblading (on my old skates) and getting faster. A lot faster!`}</p>
      <p parentName="blockquote">{`Thing is, I sort of jumped into the deep end with this. `}<a parentName="p" {...{
          "href": "http://twitter.com/zidarsk8"
        }}>{`@zidarsk8`}</a>{` just showed me how to stop, I still can’t brake, I can only stop. Sort of.`}</p>
    </blockquote>
    <p>{`And `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/today-i-nearly-died-four-times/swizec/3251"
      }}>{`a longboard almost killed me`}</a>{` ... four times ... in a single day.`}</p>
    <p>{`But I love it! Longboarding is the single funnest thing you can do offline. From what I hear the only thing that might possibly compare is surfing, but that comes with all sorts of costs and traveling and other silly things that I don't really have time for.`}</p>
    <p>{`A longboard is simple.`}</p>
    <p>{`You step outside, you live in an asphalt jungle, and you ride like the wind. It's even better when you go on a longboarding trip for the whole day with a bunch of other `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Newbie",
        "title": "Newbie"
      }}>{`noobs`}</a>{` and some guys who can show you how to use these things.`}</p>
    <p>{`You're kind of tired the next day and you might have a sore knee or two ... worth it! :D`}</p>
    <p>{`If you have a longboard at home, you should totally join us whenever the full day class is happening next. Well, I guess you'd also have to be from Slovenia, otherwise it might be a bit impractical.`}</p>
    <p>{`The whole first class was caught on video, but I'm told it's been lost to science, so here are some cool photos instead:`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/04/532741_347692488612202_146707288710724_862300_619788079_n.jpg",
        "alt": "Road cleanup",
        "title": "Road cleanup"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/04/576025_347695228611928_146707288710724_862355_1226691061_n.jpg",
        "alt": "Learning to turn tightly",
        "title": "Learning to turn tightly"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/04/534032_347697751945009_146707288710724_862396_809260405_n.jpg",
        "alt": "Turning at speed",
        "title": "Turning at speed"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/04/544490_347698501944934_146707288710724_862407_1345953820_n.jpg",
        "alt": "Yes, speed!",
        "title": "Yes, speed!"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/04/555476_347699688611482_146707288710724_862427_1778477533_n.jpg",
        "alt": "Wheee",
        "title": "Wheee"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/04/535752_347700888611362_146707288710724_862446_973054401_n.jpg",
        "alt": "First class group shot",
        "title": "First class group shot"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/04/563573_351609458220505_146707288710724_872024_2059221382_n.jpg",
        "alt": "Learning the cross-step",
        "title": "Learning the cross-step"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/04/522486_351608958220555_146707288710724_872006_151528080_n.jpg",
        "alt": "This happens if you skip a class and don't learn how to footbreak",
        "title": "This happens if you skip a class and don't learn how to footbreak"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/04/558527_351610218220429_146707288710724_872053_1299898577_n.jpg",
        "alt": "Something ...",
        "title": "Something ..."
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/04/536436_351614011553383_146707288710724_872115_1191131204_n.jpg",
        "alt": "Powersliding!",
        "title": "Powersliding!"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/04/523376_351613951553389_146707288710724_872114_1267428967_n.jpg",
        "alt": "The girls were naturals",
        "title": "The girls were naturals"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/04/554413_351614118220039_146707288710724_872118_401969108_n.jpg",
        "alt": "Yep, naturals.",
        "title": "Yep, naturals."
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/04/539879_351613898220061_146707288710724_872111_696417144_n1.jpg",
        "alt": "Once, only once, I managed to get up normally :P",
        "title": "Once, only once, I managed to get up normally :P"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/04/542112_351614551553329_146707288710724_872132_517478043_n.jpg",
        "alt": "Second class group shot",
        "title": "Second class group shot"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://surfabike.wordpress.com/2012/01/24/longboard-crew/"
        }}>{`Longboard Crew`}</a>{` (surfabike.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://r.zemanta.com/?u=http%3A//www.canada.com/sports/North%2BVancouver%2Bponders%2Bwhat%2Babout%2Blongboarding/6247724/story.html&a=78522895&rid=d81a0a49-2de8-47a5-8580-724978505d10&e=60999298dbd70113bd43812e56b679ff"
        }}>{`North Vancouver ponders what to do about longboarding`}</a>{` (canada.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.gadling.com/2012/02/29/video-of-the-day-hawaii-longboarding-big-island-and-oahu/"
        }}>{`Video of the day: Hawaii longboarding, Big Island and Oahu`}</a>{` (gadling.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.pbpulse.com/dining/brunch/2012/03/30/that-girl-longboards-makes-brunch-a-laid-back-affair/"
        }}>{`That Girl: Longboards makes brunch a laid-back affair`}</a>{` (pbpulse.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.geekologie.com/2012/04/gandalf-on-skateboard-casts-you-shall-no.php"
        }}>{`Gandalf On Skateboard Casting 'You Shall Not Pass'`}</a>{` (geekologie.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=d81a0a49-2de8-47a5-8580-724978505d10",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      